import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import ToggleButtonWrapper from '../collections/ToggleButtonWrapper';

const LANGUAGES = [ 
    { id: 'de', label: 'Deutsch' },
    { id: 'en', label: 'English' },
    { id: 'es', label: 'Español' },
    { id: 'mx', label: 'Español (México)' },
    { id: 'fr', label: 'Français' }, 
    { id: 'it', label: 'Italiano' },
    { id: 'pt', label: 'Português (Brasil)' },
    { id: 'ru', label: 'Русский' },
    { id: 'ko', label: '한국어' },
    { id: 'cn', label: '简体中文' },
    { id: 'tw', label: '繁體中文' }
];

export default class LanguageDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    toggle = (event) => {
        const show = this.state.show ? false : event.currentTarget;
        this.setState({ show });
    }

    select = (prop, id) => {
        if (id === 'en') {
            localStorage.removeItem('wowhead.language');
        } else {
            localStorage.setItem('wowhead.language', id);
        }
        this.setState({ show: false });
    }

    render() {
        const current = localStorage.getItem('wowhead.language') || 'en';
        return (
            <>
                <Tooltip title={this.state.show ? null : 'Configures which language to use for Wowhead links and tooltips'}>
                    <button type="button" className="btn btn-primary text-nowrap" onClick={this.toggle}>
                        Wowhead <FontAwesomeIcon icon={this.state.show ? faChevronUp : faChevronDown} />
                    </button>
                </Tooltip>

                <Popper open={this.state.show} anchorEl={this.state.show} placement="bottom-start">
                    <ClickAwayListener onClickAway={this.toggle}>
                        <div className="card mt-1">
                            <div className="btn-group-vertical scroller">
                                {LANGUAGES.map(l => <ToggleButtonWrapper key={l.id} id={l.id} label={l.label} checked={l.id === current} onToggle={this.select} />)}
                            </div>
                        </div>
                    </ClickAwayListener>
                </Popper>
            </>
        );
    }
}